import styled from 'styled-components'

export const CheckboxesContainer = styled.div.attrs(props => ({
    className: props.className
}))`
  & .hidden {
    visibility: hidden;
  }
  
  & .visible {
    visibility: visible;
  }
  opacity: 0;
  background-color: white;
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 100;
  
  .checkboxes {
    padding: 0.5rem 0;
    
    .list {
      display: flex;
      align-items: center;
      padding: 0.25rem 0.5rem;

      .option {
         padding-left: 1rem;
       }
    }
  }
  
  .bottomLabel {
    height: 3.125rem;
    background-color: #134074;
    display: flex;
    justify-content: space-between;
    
    .buttonWhite {
      background-color: inherit;
      border: none;
      color: white;
      padding-left: 1rem;
    }
    .buttonBigBlue {
      font-size: 14px;
      line-height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgb(1, 57, 160);
      background: rgb(255, 255, 255);
      border-radius: 4px;
      border: none;
      margin: 0.35rem;
      padding: 1rem;
    }
  }
`
